import { jsx } from 'react/jsx-runtime';
import { useContext } from 'react';
import { FixedBannerContext } from '../FixedBanner.Context/FixedBanner.Context.es.js';

const FixedBannerFooter = ({ children, ...props })=>{
    const { multiline } = useContext(FixedBannerContext);
    // We only render the Footer in multiline mode
    if (!multiline) {
        console.warn('<FixedBanner.Footer/> can not be used in single-line mode. Use `multiline` for <FixedBanner.Footer/> to render.');
        return null;
    }
    return jsx("div", {
        className: "footer",
        ...props,
        children: children
    });
};
FixedBannerFooter.displayName = 'FixedBanner.Footer';

export { FixedBannerFooter };
//# sourceMappingURL=FixedBanner.Footer.es.js.map
